import { render, staticRenderFns } from "./Deduction.vue?vue&type=template&id=62b08864"
import script from "./Deduction.vue?vue&type=script&lang=js"
export * from "./Deduction.vue?vue&type=script&lang=js"
import style0 from "./Deduction.vue?vue&type=style&index=0&id=62b08864&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports